export default __webpack_public_path__ + "static/michelin-86da3869ffeaa6e8ef96c308966f4f0a.svg";